export const PACKAGE_NAME = '@atlassian/jira-atlassian-navigation' as const;
export const TEAM_NAME = 'navigation' as const;

export const DEFAULT_LOAD_COUNT_FAV = 15;
export const DEFAULT_LOAD_COUNT_VIEWED = 10;
export const DEFAULT_LOAD_COUNT_RECENT = 5;

export const TOP_LEVEL_ERROR_BOUNDARY_ID = 'TOP_LEVEL';

export const NAVIGATION_ITEM_ID = {
	ADDONS: 'apps',
	CREATE: 'createIssue',
	APP_SWITCHER: 'atlassianSwitcher',
	DASHBOARDS: 'dashboards',
	FILTERS: 'filters',
	HELP: 'help',
	HELP_BADGE: 'helpBadge',
	HOME: 'home',
	INSIGHT: 'insight',
	LOGO: 'productLogo',
	NOTIFICATIONS: 'notifications',
	PEOPLE: 'people',
	PLANS: 'plans',
	PROFILE: 'profile',
	PROJECTS: 'projects',
	ROADMAPS: 'roadmaps',
	SEARCH: 'search',
	SERVICE_HUB: 'services',
	SETTINGS: 'settings',
	SIGN_IN: 'signIn',
	YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
	CONVERSATION_ASSISTANT: 'conversationAssistant',
	ROVO_DEMAND_TESTS: 'rovoDemandTests',
} as const;

export const MODAL_ID = {
	DASHBOARD_CREATE: 'DASHBOARD_CREATE',
	KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
	PROJECT_CREATE: 'PROJECT_CREATE',
} as const;

export const PROFILE_SPOTLIGHT_KEY = 'profile-spotlight';
export const HELP_SPOTLIGHT_KEY = 'help-spotlight';
export const SEARCH_SPOTLIGHT_KEY = 'search-spotlight';
export const PROJECTS_SPOTLIGHT_KEY = 'projects-spotlight';

export const EXPERIENCE_NAVIGATION_TOP_MAIN = 'viewAtlassianNavigation';
export const EXPERIENCE_NAVIGATION_TOP_MENU = 'viewAtlassianNavigationMenu';

export const YOUR_WORK_DROPDOWN_TAB_ID = {
	RECENT: 'RECENT',
	BOARDS: 'BOARDS',
	QUEUES: 'QUEUES',
	ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
	ADD_FILTER: 'ADD_FILTER',
	ALERTS: 'ALERTS',
} as const;

export const JSW_TMP_BACKLOG_BOARD_REGEXP =
	/jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
